import { z } from "zod";

import { ProfessionSchema } from "./shared";

export const HCProfessionalResponseSchema = z.object({
  avatar: z.object({
    large: z.string().nullable(),
    medium: z.string().nullable(),
    small: z.string().nullable(),
  }),
  health_care_professional_id: z.number(),
  health_care_professional_full_name: z.string(),
  profession: ProfessionSchema,
});

export type HCProfessionalResponse = z.infer<typeof HCProfessionalResponseSchema>;
